import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const insightsPlugin = createPlugin({
  id: 'insights',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindInsightsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(insightsPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...insightsPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceInsightsPage = insightsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceInsightsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-insights", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const ConfidenceInsightsExtension = insightsPlugin.provide(
  createComponentExtension({
    name: 'ConfidenceInsightsExtension',
    component: {
      lazy: () =>
        import(
          /* webpackChunkName: "confidence-insights-extension", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
    },
  }),
);
